import styled from "styled-components";

export const TabList = styled.ul`
  display: flex;
  align-items: center;
  gap: 32px;
`;
